<template>
  <div>
    <md-app md-mode="fixed">
      <md-app-toolbar class="md-primary top">

        <div class="menu-button">
          <md-button id="mnuMenu" class="md-icon-button " @click="menuVisible = !menuVisible">
            <md-icon>menu</md-icon>
          </md-button>
        </div>
        <div class="menu-container">
          <img v-if="hasLogo" class="logo-image" @click="navigateHome()" alt="NeoOffice" :src="urlPath + clientId" :onerror="'this.src=\'' + require('../assets/imgs/neooffice.png') +'\''">
          <img v-else class="logo-image" @click="navigateHome()" alt="NeoOffice" src="../assets/imgs/neooffice.png">
          <div>
            <md-menu :mdCloseOnClick="true" class="profile" md-align-trigger @md-opened="openProfile">
              <button id="mnuProfile" class="md-button md-icon-button" md-menu-trigger>
                <i class="md-icon md-icon-font md-primary">person</i>
              </button>
              <md-menu-content class="md-app-submenu">
                <md-list class="md-triple-line md-dense">
                  <md-list-item>
                    <i class="md-icon md-icon-font md-primary">person</i>
                    <div class="md-list-item-text">
                      <span>{{userName}}</span>

                      <span>{{userEmail}}</span>
                      <a id="mnuProfileExit" @click="signout">{{$t('logout')}}</a>
                    </div>
                  </md-list-item>
                </md-list>
                <md-list v-if="!isGlobalAdminHostname && hasBookingFeatures && !hideMenuOptions" class="md-dense">

                  <md-divider ></md-divider>

                  <md-list-item id="mnuProfileSettings" @click="$router.push('/organization/user/settings')">
                    <i class="md-icon md-icon-font md-primary">settings</i>
                    <span id="configuration" class="md-list-item-text">{{ $t('preferences') }}</span>
                  </md-list-item>
                  <md-list-item id="mnuProfilePrivacy" @click="$router.push('/organization/document?item=privacyPolicy')">
                    <i class="md-icon md-icon-font md-primary">visibility</i>
                    <span class="md-list-item-text">{{ $t('privacyPolicy') }}</span>
                  </md-list-item>
                  <md-list-item id="mnuProfileTerms" @click="$router.push('/organization/document?item=termsOfUse')">
                    <i class="md-icon md-icon-font md-primary">list_alt</i>
                    <span  class="md-list-item-text">{{ $t('termsOfUse') }}</span>
                  </md-list-item>


                </md-list>
              </md-menu-content>
            </md-menu>
          </div>
        </div>

      </md-app-toolbar>

      <md-app-drawer v-if="!hideMenuOptions" id="leftMenu" :class="{'closedMenu': !menuVisible}" :md-active.sync="menuVisible">

        <md-list @mouseover="toggleMenu(true)" @mouseleave="toggleMenu(false)" :class="[menuVisible ? 'side-menu-opened': 'side-menu-closed']" :md-expand-single="true">
            <md-list-item key="0" v-show="hasAnyMenuExpanded" id="mnuCloseExpanded" @click="closeMenuExpanded">
              <i class="md-icon md-icon-font md-primary">arrow_back</i>
              <span class="md-list-item-text md-body-1 md-primary">{{$t('mainMenu')}}</span>
            </md-list-item>

            <md-list-item key="1" v-show="!hasAnyMenuExpanded" id="mnuSchedules" v-if="!isGlobalAdminHostname && hasBookingFeatures" @click="navigate('/organization/user/bookings')">
              <i class="md-icon md-icon-font md-primary">event</i>
              <span class="md-list-item-text">{{$t('schedules')}}</span>
            </md-list-item>

            <md-list-item key="2" v-show="!hasAnyMenuExpanded || menuExpanded[0]" id="mnuBook" v-if="!isGlobalAdminHostname && hasBookingFeatures" md-expand :md-expanded.sync="menuExpanded[0]">
              <i class="md-icon md-icon-font md-primary">book_online</i>
              <span class="md-list-item-text">{{$t('book')}}</span>
              <md-list slot="md-expand">
                <list-role-item :isPublic="bookMenuIsPublic(menu.name)" :toggle="!menu.validateFeature || hasBookingFor[menu.name] && hasInviteTeamFeatureFlagForMenu(menu.name)" v-for="(menu, index) in bookMenu" :key="index" :route="menu.route">{{ $t(menu.name) }}</list-role-item>
              </md-list>
            </md-list-item>

            <md-list-item key="3" v-show="!hasAnyMenuExpanded" id="mnuOccupancy" v-if="!isGlobalAdminHostname && hasBookingFeatures && hasMonitoring" @click="navigate('/desk4me/space/occupancy')">
              <i class="md-icon md-icon-font md-primary">workspaces</i>
              <span class="md-list-item-text">{{$t('occupancy')}}</span>
            </md-list-item>

            <md-list-item key="4" v-show="!hasAnyMenuExpanded || menuExpanded[1]" id="mnuTeam" v-if="!isGlobalAdminHostname && hasInviteTeamFeatureFlag" md-expand  :md-expanded.sync="menuExpanded[1]">
              <i class="md-icon md-icon-font md-primary">groups</i>
              <span class="md-list-item-text">{{ $t('team') }}</span>
              <md-list slot="md-expand" :md-expand-single="true">
                <md-list-item id="mnuTeamMyTeam" class="md-inset" @click="navigate('/organization/team')">{{ $t('myTeam') }}</md-list-item>
                <md-list-item id="mnuTeamInvites" class="md-inset" @click="navigate('/organization/team/invite')">{{ $t('invites') }}</md-list-item>
              </md-list>
            </md-list-item>

            <md-list-item key="5" v-show="!hasAnyMenuExpanded" v-if="isGlobalAdminHostname && (originalDesk4MeId === null && originalFreeroomId === null)" @click="navigate('/organization/clients')">
              <i class="md-icon md-icon-font md-primary">person_outline</i>
              <span class="md-list-item-text">{{$t('clients')}}</span>
            </md-list-item>

            <md-list-item key="6" v-show="!hasAnyMenuExpanded || menuExpanded[2]" v-if="isGlobalAdminHostname && (originalDesk4MeId === null && originalFreeroomId === null)" md-expand :md-expanded.sync="menuExpanded[2]">
              <i class="md-icon md-icon-font md-primary">devices_other</i>
              <span class="md-list-item-text">{{$t('devices')}}</span>
               <md-list slot="md-expand">
                 <md-list-item class="md-inset" @click="navigate('/organization/admin/global/tablets')">{{ $t('tablets') }}</md-list-item>
                 <md-list-item class="md-inset" @click="navigate('/organization/admin/global/cameras')">{{ $t('cameras') }}</md-list-item>
                 <md-list-item class="md-inset" @click="navigate('/organization/admin/global/tvs')">{{ $t('tvs') }}</md-list-item>
                 <md-list-item class="md-inset" @click="navigate('/organization/admin/global/comfortpack')">Comfort Pack</md-list-item>
                 <md-list-item class="md-inset" @click="navigate('/organization/admin/global/spaces2check')">{{ $t('Space2Check') }}</md-list-item>
                </md-list>
            </md-list-item>

            <md-list-item key="7" v-show="!hasAnyMenuExpanded" v-if="isGlobalAdminHostname && (originalDesk4MeId === null && originalFreeroomId === null)" @click="navigate('/desk4me/admin/qrcodes')">
              <i class="md-icon md-icon-font md-primary">qr_code</i>
              <span class="md-list-item-text">{{$t('qrCodes')}}</span>
            </md-list-item>

            <md-list-item key="8" v-show="!hasAnyMenuExpanded" v-if="isGlobalAdminHostname && (originalDesk4MeId === null && originalFreeroomId === null)" @click="navigate('/organization/admin/global/featureflags')">
              <i class="md-icon md-icon-font md-primary">edit_attributes</i>
              <span class="md-list-item-text">{{$t('features')}}</span>
            </md-list-item>

            <md-list-item key="9" v-show="!hasAnyMenuExpanded" v-if="isGlobalAdminHostname && (originalDesk4MeId === null && originalFreeroomId === null)" @click="navigate('/organization/admin/global/application/settings')">
              <i class="md-icon md-icon-font md-primary">settings</i>
              <span class="md-list-item-text">{{$t('applicationSettings')}}</span>
            </md-list-item>

            <md-list-item key="10" v-show="!hasAnyMenuExpanded" v-if="isGlobalAdminHostname && (hasWorkspaceAndOriginalDesk4MeId || hasMeetingSpaceAndOriginalFreeRoomId)" @click="navigate('/organization/admin/global/features')">
              <i class="md-icon md-icon-font md-primary">toggle_on</i>
              <span class="md-list-item-text">{{$t('features')}}</span>
            </md-list-item>

            <md-list-item key="11" v-show="!hasAnyMenuExpanded || menuExpanded[3]" v-if="(hasWorkspaceAndOriginalDesk4MeId && isGlobalAdminHostname) && hasBookingFeatures" md-expand :md-expanded.sync="menuExpanded[3]">
              <i class="md-icon md-icon-font md-primary">workspaces</i>
              <span class="md-list-item-text">{{ $t('workspaces') }}</span>

              <md-list slot="md-expand">
                <md-list-item class="md-inset" @click="navigate('/organization/admin/locations')">{{ $t('locations') }}</md-list-item>
                <md-list-item class="md-inset" @click="navigate('/desk4me/admin/chartered')">{{ $t('charteredBuses') }}</md-list-item>
                <md-list-item class="md-inset" @click="navigate('/desk4me/admin/restaurants')">{{ $t('restaurants') }}</md-list-item>
                <md-list-item class="md-inset" @click="navigate('/desk4me/admin/parkings')">{{ $t('parkings') }}</md-list-item>
              </md-list>
            </md-list-item>

            <md-list-item key="12" v-show="!hasAnyMenuExpanded" v-if="(hasWorkspaceAndOriginalDesk4MeId && isGlobalAdminHostname) && hasBookingFeatures" @click="navigate('/desk4me/admin/regions')">
              <i class="md-icon md-icon-font md-primary">group_work</i>
              <span class="md-list-item-text">{{$t('regions')}}</span>
            </md-list-item>
            <list-role key="13" v-show="!hasAnyMenuExpanded || menuExpanded[4]" id="mnuManage" :toggle="((hasWorkspaceAndOriginalDesk4MeId || hasMeetingSpaceAndOriginalFreeRoomId) && hasComfort) || (!isGlobalAdminHostname && hasComfort)" :menuExpanded.sync="menuExpanded[4]">
              <i class="md-icon md-icon-font md-primary">corporate_fare</i>
              <span class="md-list-item-text">{{ $t('office') }}</span>

              <md-list slot="md-expand" :md-expand-single="true">
                <list-role-item id="mnuManageDashdSensors" :toggle="hasComfort" :route="'/organization/admin/dashboards/sensors'">{{ $t('comfort') }}</list-role-item>
                <list-role-item id="mnuComfortAlerts" :toggle="hasComfort" :route="'/organization/admin/alerts'">{{ $t('alerts') }}</list-role-item>
              </md-list>
            </list-role>

            <md-list-item key="14" v-if="hasMonitoring && (hasNeoAiFeatureFlag || isGlobalAdminHostname)" v-show="!hasAnyMenuExpanded" id="neoAi" @click="navigate('/organization/neoai')">
              <md-icon class="neo-ai-icon" :md-src="require('../assets/svg/neo-ai.svg')"/>
              <span class="md-list-item-text">Neo.ai</span>
            </md-list-item>

            <md-list-item key="15" v-show="!hasAnyMenuExpanded" id="mnuContact" v-if="!isGlobalAdminHostname && hasContactForm" @click="navigate('/organization/contact')">
              <i class="md-icon md-icon-font md-primary">mail</i>
              <span class="md-list-item-text">{{ $t('contact') }}</span>
            </md-list-item>

            <list-role key="16" v-show="!hasAnyMenuExpanded || menuExpanded[5]" id="mnuManage" :toggle="(hasWorkspaceAndOriginalDesk4MeId || hasMeetingSpaceAndOriginalFreeRoomId) || !isGlobalAdminHostname" :menuExpanded.sync="menuExpanded[5]">
              <i class="md-icon md-icon-font md-primary">manage_search</i>
              <span class="md-list-item-text">{{ $t('manage') }}</span>

              <md-list slot="md-expand" :md-expand-single="true">
                <list-role-item id="mnuManageBookings" :toggle="hasBookingForDesk" :route="'/desk4me/admin/manage/booking'">{{ $t('desks') }}</list-role-item>
                <sub-list-role id="mnuManageRoomBookings" :menuExpanded.sync="subMenuExpanded[0]">
                  <span class="md-list-item-text sub-menu-text">{{ $t('rooms') }}</span>
                  <md-list slot="md-expand">
                    <list-role-item id="mnuManageProtectReservation" :toggle="hasBookingForRoom" :route="'/freeroom/admin/protect'">{{ $t('protectReservation') }}</list-role-item>
                    <list-role-item id="mnuManageBookingApproval" :toggle="hasBookingForRoom" :route="'/freeroom/admin/approval'">{{ $t('approvalReservation') }}</list-role-item>
                  </md-list>
                </sub-list-role>
                <list-role-item id="mnuManageCharteredBusBookings" :toggle="hasBookingForChartered" :route="'/desk4me/admin/manage/charteredBusBooking'">{{ $t('charteredBuses') }}</list-role-item>
                <list-role-item id="mnuManageRestaurantBookings" :toggle="hasBookingForRestaurant" :route="'/desk4me/admin/manage/restaurantBooking'">{{ $t('restaurants') }}</list-role-item>
                <list-role-item id="mnuManageLockerBookings" :toggle="hasBookingForLocker" :route="'/desk4me/admin/manage/lockerBooking'">{{ $t('lockers') }}</list-role-item>
                <list-role-item id="mnuManageParkingBookings" :toggle="hasBookingForParking" :route="'/desk4me/admin/manage/parkingBooking'">{{ $t('parkings') }}</list-role-item>
              </md-list>
            </list-role>

            <list-role key="17" v-show="!hasAnyMenuExpanded || menuExpanded[6]" id="mnuReportsDash" :toggle="((hasWorkspaceAndOriginalDesk4MeId || hasMeetingSpaceAndOriginalFreeRoomId) || !isGlobalAdminHostname) && hasBookingFeatures" :menuExpanded.sync="menuExpanded[6]">
              <i class="md-icon md-icon-font md-primary">dashboard</i>
              <span class="md-list-item-text">{{ $t('dashboards') }}</span>
              <md-list slot="md-expand" :md-expand-single="true">


                <sub-list-role id="mnuReportsDashSub" :menuExpanded.sync="subMenuExpanded[1]">
                  <span class="md-list-item-text sub-menu-text">{{ $t('desks')}}</span>
                  <md-list slot="md-expand">
                    <list-role-item id="mnuReportsDashDesk" :toggle="hasBookingForDesk || hasMonitoring" :route="'/desk4me/admin/dashboards/desk'">{{ $t('bookings') }}</list-role-item>
                    <list-role-item id="mnuReportsDashDesksMonitoring" :toggle="hasMonitoring" :route="'/desk4me/admin/dashboards/monitoring'">{{ $t('featureMonitoring') }}</list-role-item>
                  </md-list>
                </sub-list-role>

                <sub-list-role id="mnuReportsDashRoom" :menuExpanded.sync="subMenuExpanded[2]">
                  <span class="md-list-item-text sub-menu-text">{{ $t('rooms') }}</span>
                  <md-list slot="md-expand">
                    <list-role-item id="mnuReportsDashBookingRooms" :toggle="hasBookingForRoom" :route="'/freeroom/admin/dashboards/rooms'">{{ $t('bookings') }}</list-role-item>
                    <list-role-item id="mnuReportsDashRoomsMonitoring" :toggle="hasBookingForRoom && hasFrMonitoring" :route="'/freeroom/admin/dashboards/monitoring'">{{ $t('featureMonitoring') }}</list-role-item>
                  </md-list>
                </sub-list-role>
                <list-role-item id="mnuReportsDashChartered" :toggle="hasBookingForChartered" :route="'/desk4me/admin/dashboards/chartered'">{{ $t('charteredBuses') }}</list-role-item>
                <list-role-item id="mnuReportsDashRestaurant" :toggle="hasBookingForRestaurant" :route="'/desk4me/admin/dashboards/restaurant'">{{ $t('restaurants') }}</list-role-item>
                <list-role-item id="mnuReportsDashParking" :toggle="hasBookingForParking" :route="'/desk4me/admin/dashboards/parking'">{{ $t('parkings') }}</list-role-item>
                <list-role-item id="mnuManageDashdDevices" :toggle="hasBookingFeatures" :route="'/organization/admin/dashboards/devices'">{{ $t('devices') }}</list-role-item>
                <list-role-item id="mnuReportsDashdComfort" :toggle="hasComfort" :route="'/desk4me/admin/dashboards/comfort'">{{ $t('comfort') }}</list-role-item>
                <list-role-item id="mnuReportsDashOccupancy" :toggle="hasReportsDashOccupancy" :route="'/organization/admin/dashboards/occupancy'">{{ $t('occupancy') }}</list-role-item>
              </md-list>
            </list-role>

            <list-role key="18" v-show="!hasAnyMenuExpanded || menuExpanded[7]" id="mnuReportsOp" :toggle="(hasWorkspaceAndOriginalDesk4MeId || hasMeetingSpaceAndOriginalFreeRoomId) || !isGlobalAdminHostname" :menuExpanded.sync="menuExpanded[7]">
              <i class="md-icon md-icon-font md-primary">summarize</i>
              <span class="md-list-item-text">{{ $t('reports') }}</span>
              <md-list slot="md-expand" :md-expand-single="true">
                <list-role-item id="mnuReportsOpMaps" :toggle="hasBookingForDesk" :route="'/desk4me/admin/reports/maps'">{{ $t('maps') }}</list-role-item>
                <sub-list-role id="mnuReportsBookings" :menuExpanded.sync="subMenuExpanded[3]">
                  <span class="md-list-item-text sub-menu-text">{{ $t('bookings') }}</span>
                  <md-list slot="md-expand">
                    <list-role-item id="mnuReportsOpDesks" :toggle="hasBookingForDesk" :route="'/desk4me/admin/reports/desk'">{{ $t('desks') }}</list-role-item>
                    <list-role-item id="mnuReportsOpCoworkers" :toggle="hasBookingForDesk" :route="'/desk4me/admin/reports/anotherPersonAndGuest'">{{ $t('anotherPersonAndGuest') }}</list-role-item>
                    <list-role-item id="mnuReportsRoomEvents" :toggle="hasBookingForRoom && hasFrReportProcessing" :route="'/freeroom/admin/reports/roomEvent'">{{ $t('rooms') }}</list-role-item>
                    <list-role-item id="mnuReportsOpCharteredBuses" :toggle="hasBookingForChartered" :route="'/desk4me/admin/reports/chartered'">{{ $t('charteredBuses') }}</list-role-item>
                    <list-role-item id="mnuReportsOpRestaurants" :toggle="hasBookingForRestaurant" :route="'/desk4me/admin/reports/restaurant'">{{ $t('restaurants') }}</list-role-item>
                    <list-role-item id="mnuReportsOpLockers" :toggle="hasBookingForLocker" :route="'/desk4me/admin/reports/locker'">{{ $t('lockers') }}</list-role-item>
                    <list-role-item id="mnuReportsOpParkings" :toggle="hasBookingForParking" :route="'/desk4me/admin/reports/parking'">{{ $t('parkings') }}</list-role-item>
                  </md-list>
                </sub-list-role>
                <list-role-item id="mnuReportsRestrictions" :toggle="hasBookingForDesk || hasBookingForParking" :route="'/organization/admin/reports/restrictions'">{{ $t('restrictions') }}</list-role-item>
                <list-role-item id="mnuReportsOpUnbookedEntrances" :toggle="hasBookingFeatures && hasAccessControl" :route="'/organization/admin/reports/unbookedEntrance'">{{ $t('unbookedEntrances') }}</list-role-item>
              </md-list>
            </list-role>

            <list-role key="19" v-show="!hasAnyMenuExpanded || menuExpanded[8]" id="mnuServices" :toggle="(hasWorkspaceAndOriginalDesk4MeId || hasMeetingSpaceAndOriginalFreeRoomId) || !isGlobalAdminHostname" :menuExpanded.sync="menuExpanded[8]">
              <i class="md-icon md-icon-font md-primary">room_service</i>
              <span class="md-list-item-text">{{ $t('services') }}</span>
              <md-list slot="md-expand">
                <list-role-item id="mnuServicesServiceDeskRequest" :toggle="hasMeetingSpace && isServiceDeskEnabled && hasBookingForRoom" :route="'/freeroom/admin/service'">{{ $t('serviceDeskRooms') }}</list-role-item>
                <list-role-item id="mnuServicesServiceDesk" :toggle="(hasWorkspace && hasServiceDesk) && (hasBookingFeatures || hasMonitoring)" :route="'/desk4me/admin/manage/service'">{{ $t('serviceDesk') }}</list-role-item>
                <list-role-item id="mnuServicesSuppliers" :toggle="hasMeetingSpace && isServiceDeskEnabled && hasBookingForRoom" :route="'/freeroom/admin/clients/supplier'">{{ $t('suppliers') }}</list-role-item>
                <list-role-item id="mnuServicesFoods" :toggle="hasMeetingSpace &&  isServiceDeskEnabled && hasBookingForRoom" :route="'/freeroom/admin/clients/supplier/foods'">{{ $t('foods') }}</list-role-item>
                <list-role-item id="mnuServicesEquipments" :toggle="hasMeetingSpace && isServiceDeskEnabled && hasBookingForRoom" :route="'/freeroom/admin/clients/supplier/equipments'">{{ $t('equipments') }}</list-role-item>
              </md-list>
            </list-role>

            <list-role key="20" v-show="!hasAnyMenuExpanded || menuExpanded[9]" id="mnuAccessControl" :toggle="hasNeoAccessFeatureFlag && hasAccessControl && (hasWorkspaceAndOriginalDesk4MeId || hasMeetingSpaceAndOriginalFreeRoomId) || !isGlobalAdminHostname" :menuExpanded.sync="menuExpanded[9]">
              <i class="md-primary material-symbols-outlined">shield_lock</i>
              <span class="md-list-item-text">{{$t('accessControl')}}</span>
              <md-list slot="md-expand" :md-expand-single="true">
                <list-role-item id="mnuAccessControlAreas" :toggle="hasNeoAccessFeatureFlag && hasAccessControl" :route="'/organization/access-control/areas'">{{ $t('areas') }}</list-role-item>
                <list-role-item id="mnuAccessControlAccesses" :toggle="hasNeoAccessFeatureFlag && hasAccessControl" :route="'/organization/access-control/accesses'">{{ $t('accesses') }}</list-role-item>
              </md-list>
            </list-role>

            <list-role key="21" v-show="!hasAnyMenuExpanded || menuExpanded[10]" id="mnuAdministratorDesk4me" :toggle="(hasWorkspaceAndOriginalDesk4MeId || hasMeetingSpaceAndOriginalFreeRoomId) || !isGlobalAdminHostname" :menuExpanded.sync="menuExpanded[10]">
              <i class="md-icon md-icon-font md-primary">supervisor_account</i>
              <span class="md-list-item-text">{{$t('admin')}}</span>
              <md-list slot="md-expand" :md-expand-single="true">
                <list-role-item id="mnuAdminUsers" :route="'/organization/admin/users'">{{ $t('users') }}</list-role-item>
                <sub-list-role id="mnuAdminGroups" :menuExpanded.sync="subMenuExpanded[4]">
                  <span class="md-list-item-text sub-menu-text">{{ $t('groups') }}</span>
                  <md-list slot="md-expand">
                    <list-role-item id="mnuAdminEmployeeGroups" :toggle="hasBookingFeatures" :route="'/organization/admin/groups/employees'">{{ $t('employeeGroups') }}</list-role-item>
                    <list-role-item id="mnuAdminDeskGroups" :toggle="hasBookingForDesk || hasMonitoring" :route="'/desk4me/admin/groups/desks'">{{ $t('deskGroups') }}</list-role-item>
                    <list-role-item id="mnuAdminNotificationGroups" :toggle="hasBookingFeatures" :route="'/organization/admin/groups/notification'">{{ $t('notificationGroups') }}</list-role-item>
                  </md-list>
                </sub-list-role>
                <sub-list-role id="mnuAdminMeal" :toggle="hasBookingForRestaurant && hasMealFeatureFlag" :menuExpanded.sync="subMenuExpanded[5]">
                  <span class="md-list-item-text sub-menu-text">{{ $t('meals') }}</span>
                  <md-list slot="md-expand">
                    <list-role-item id="mnuTypeOfMeal" :route="'/desk4me/admin/meal/types'">{{ $t('typesOfMeals') }}</list-role-item>
                    <list-role-item id="mnuMealMenu" :route="'/desk4me/admin/meal/menus'">{{ $t('mealMenu') }}</list-role-item>
                  </md-list>
                </sub-list-role>
                <sub-list-role id="mnuAdminRoom" :menuExpanded.sync="subMenuExpanded[6]">
                  <span class="md-list-item-text sub-menu-text">{{ $t('rooms') }}</span>
                  <md-list slot="md-expand">
                    <list-role-item id="mnuAdminRoomsCalendar" :toggle="hasBookingForRoom" :route="'/freeroom/admin/clients/edit/calendar/provider'">{{ $t('calendar') }}</list-role-item>
                    <list-role-item :toggle="hasBookingForRoom" :route="'/freeroom/admin/clients/locations'">{{ $t('locations') }}</list-role-item>
                    <list-role-item :toggle="hasBookingForRoom" :route="'/freeroom/admin/clients/edit/equipment'">{{ $t('equipments') }}</list-role-item>
                    <list-role-item :toggle="hasBookingForRoom" :route="'/freeroom/admin/clients/edit/device'">{{ $t('devices') }}</list-role-item>
                    <list-role-item id="mnuAdminSettingsRooms" :toggle="hasBookingForRoom" :route="'/freeroom/admin/clients/location/rooms'">{{ $t('settings') }}</list-role-item>
                  </md-list>
                </sub-list-role>
                <sub-list-role id="mnuAdminSettings" :menuExpanded.sync="subMenuExpanded[7]">
                  <span class="md-list-item-text sub-menu-text">{{ $t('settings') }}</span>
                  <md-list slot="md-expand">
                    <list-role-item id="mnuAdminFeatures" :route="'/organization/admin/settings/features'">{{ $t('global') }}</list-role-item>
                    <list-role-item id="mnuAdminSettingsSites" :toggle="hasWorkspace" :route="'/desk4me/admin/sites'">{{ $t('site') }}</list-role-item>
                  </md-list>
                </sub-list-role>

                <list-role-item id="mnuAdminRestrictions" :toggle="hasBookingForDesk || hasBookingForParking" :route="'/organization/admin/restrictions'">{{ $t('bookRestrictions') }}</list-role-item>
                <list-role-item id="mnuAdminDeskAttributes" :toggle="hasBookingForDesk" :route="'/desk4me/admin/desk/attributes'">{{ $t('deskAttributes') }}</list-role-item>
                <list-role-item id="mnuAdminAdministrators" :route="'/organization/admin/administrators/global'">{{ $t('permissions') }}</list-role-item>

                <list-role-item id="mnuTypeOfService" :toggle="hasServiceDesk && isGlobalAdminHostname" :route="'/desk4me/admin/service/types'">{{ $t('typeOfService') }}</list-role-item>
                <list-role-item id="mnuAdminContact" :toggle="hasContactForm" :route="'/organization/admin/contact'">{{ $t('contact') }}</list-role-item>
              </md-list>
            </list-role>

            <md-list-item key="22" v-show="!hasAnyMenuExpanded" v-if="(originalDesk4MeId !== null || originalFreeroomId !== null) && isGlobalAdminHostname" @click="clearId()">
              <i class="md-icon md-icon-font md-primary">exit_to_app</i>
              <span class="md-list-item-text">{{$t('exitConfig')}}</span>
            </md-list-item>

            <md-list-item key="23" v-show="!hasAnyMenuExpanded || menuExpanded[11]" v-if="isMobile" class="profile-mobile" md-expand :md-expanded.sync="menuExpanded[11]">
              <i class="md-icon md-icon-font md-primary">person</i>
              <span class="md-list-item-text">{{ userName ? userName : $t('profile')}}</span>
              <md-list slot="md-expand">
                <md-list-item v-if="!hideMenuOptions" class="md-inset" @click="navigate('/organization/user/settings')">
                  {{ $t('preferences') }}
                </md-list-item>
                <md-list-item v-if="!hideMenuOptions" class="md-inset" @click="navigate('/organization/document?item=privacyPolicy')">
                  {{ $t('privacyPolicy') }}
                </md-list-item>
                <md-list-item v-if="!hideMenuOptions" class="md-inset" @click="navigate('/organization/document?item=termsOfUse')">
                  {{ $t('termsOfUse') }}
                </md-list-item>
                <md-list-item class="md-inset" @click="signout">
                  {{$t('logout')}}
                </md-list-item>

              </md-list>
            </md-list-item>
        </md-list>
        <div class="powered">
          <img class="logo-image" alt="Neowrk Room" src="../assets/imgs/neooffice.png">
        </div>
      </md-app-drawer>

      <md-app-content>
        <slot></slot>
      </md-app-content>
    </md-app>
  </div>
</template>

<script>

import { mapActions, mapGetters, mapState } from 'vuex'
import utils from '@/utils/utils.js'
import sharedStrings from '@/utils/sharedStrings.js'
import strings from '@/strings'

export default {
  name: 'AdminMenu',
  data: () => ({
    menuVisible: false,
    menuExpanded: [],
    subMenuExpanded: [],
    urlPath: process.env.VUE_APP_URL_LOGO_IMAGE
  }),
  computed: {
    ...mapState('Global', ['windowWidth']),
    ...mapGetters('Global', ['isMobile',
      'hasAccessControl', 'hasBookingForDesk',
      'hasMonitoring', 'hasBookingFeatures',
      'hasServiceDesk','hasBookingFor',
      'hasBookingForRestaurant', 'hasBookingForChartered',
      'hasBookingForParking', 'hasBookingForLocker',
      'isServiceDeskEnabled', 'hasBookingForRoom',
      'hasContactForm', 'hasWorkspace', 'hasMeetingSpace',
      'hasFrMonitoring', 'featureFlags', 'hasLogo', 'hasFrReportProcessing',
      'hasComfort', 'isTeamBookingOnlyByTeamManagers']),
    ...mapGetters('Auth', ['userName', 'userEmail', 'isGlobalAdminHostname', 'isGlobalAdmin']),
    ...mapGetters('Client', ['clientId', 'originalDesk4MeId', 'originalFreeroomId']),
    hideMenuOptions () {
      return this.$route.meta.hideMenuOptions
    },
    bookMenu () {
      return sharedStrings.bookMenu
    },
    hasWorkspaceAndOriginalDesk4MeId() {
      return this.hasWorkspace && this.originalDesk4MeId !== null
    },
    hasMeetingSpaceAndOriginalFreeRoomId() {
      return this.hasMeetingSpace && this.originalFreeroomId !== null
    },
    hasMealFeatureFlag() {
      return this.featureFlagIsEnabled(strings.featureFlags.meal)
    },
    hasInviteTeamFeatureFlagForMenu() {
      return menuItem => menuItem === 'team' ? this.featureFlagIsEnabled(strings.featureFlags.inviteTeam) : true
    },
    bookMenuIsPublic() {
      const teamBookMenuIsPublic = !this.isTeamBookingOnlyByTeamManagers
      return menuItem => menuItem === 'team' ? teamBookMenuIsPublic : true
    },
    hasInviteTeamFeatureFlag() {
      return this.featureFlagIsEnabled(strings.featureFlags.inviteTeam)
    },
    hasAnyMenuExpanded() {
      return this.menuExpanded.some(menu => menu === true)
    },
    hasReportsDashOccupancy() {
      return this.featureFlagIsEnabled(strings.featureFlags.dashboardOccupancy)
    },
    hasNeoAccessFeatureFlag() {
      return this.featureFlagIsEnabled(strings.featureFlags.neoAccess)
    },
    hasNeoAiFeatureFlag() {
      return this.featureFlagIsEnabled(strings.featureFlags.neoAi)
    }
  },
  methods: {
    ...mapActions('Auth', ['signout']),
    ...mapActions('DeskBooking', ['findFreeBusy']),
    ...mapActions('Client', ['restoreClient']),
    async openProfile () {
      await this.$nextTick()

      let elements = Array.from(document.getElementsByClassName('md-app-submenu'))
      elements.forEach((element) => {
        element.style.top = '64px'
        element.style.right = '5px'
      })
    },
    navigate (path) {
      this.$router.push(path).catch(() => {})
    },
    clearId () {
      this.menuVisible = false
      this.restoreClient()
    },
    navigateUrl(path){
      window.location.href = path
    },
    toggleMenu (show) {
      if (this.windowWidth > 600) {
        this.menuVisible = show
      }
    },
    closeMenuExpanded () {
      for (let i in this.menuExpanded) {
        if(this.menuExpanded[i]) {
          this.menuExpanded[i] = false
        }
      }
      for (let i in this.subMenuExpanded) {
        if(this.subMenuExpanded[i]) {
          this.subMenuExpanded[i] = false
        }
      }
      this.$forceUpdate()
    },
    navigateHome() {
      this.$router.push(utils.getLoadingPageRoute(this.isGlobalAdminHostname, this.hasBookingFeatures, this.hasMonitoring, this.hasComfort))
    },
    featureFlagIsEnabled(name) {
      if(this.featureFlags){
        const foundItem = this.featureFlags.find(item => item.name === name);
        return foundItem ? foundItem.active : false;
      }
    }
  },
  watch: {
    $route (){
      if(this.menuVisible){
        this.menuVisible = false
      }
    },
    menuVisible: function (val) {
      if (!val) {
        this.closeMenuExpanded()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~vue-material/src/components/MdLayout/mixins";

.material-symbols-outlined {
  margin-right: 32px;
}

.md-app {
  height: 100vh;
}

.md-drawer{
  top: $toolbarHeight;
  width: $menuWidthOpened;
  @include md-layout-small {
    top: $toolbarHeightSmall;

  }
  z-index: 16;
}

::v-deep .md-overlay {
  top: $toolbarHeight;
  z-index: 15;
  @include md-layout-xsmall {
    top: $toolbarHeightSmall;
  }
}

::v-deep.md-toolbar{
  @include md-layout-small {
    min-height: $toolbarHeightSmall;
  }
}

.md-app-submenu{
  left: auto;
  width: 100%;
}

img{
  height: calc(#{$toolbarHeight} - 23px) !important;
  padding: 0 10px 0 10px;
}

@media only screen and (max-width: 960px) {
  img{
    height: calc(#{$toolbarHeight} - 30px) !important;
    padding: 0 5px 0 5px;
  }

  .top-buttons{
    display: none;
  }
}

.md-drawer {
  transform: none;
  transition: width .3s;

  @include md-layout-xsmall {
    width: 100vw;
    max-width: none;
  }
}

.side-menu-opened{
  height: calc(100vh - 116px);
  overflow: auto;
}

.side-menu-closed{
  height: calc(100vh - 116px);
  overflow: hidden;
}

.closedMenu{
  width: $menuWidthClosed;
  border-right: 1px solid #e1e1e1;
  z-index: 4;
  @include md-layout-xsmall {
    width: 0;
  }
}

.md-content {
  margin-left: $menuWidthClosed;
  height: auto;

  @include md-layout-xsmall {
    margin-left: 0;
  }
}

.menu-button{
  width: $menuWidthClosed;

}

.md-app-toolbar.top {
  padding-left: 0;
  padding-right: 0;
  box-shadow: 0 3px 29px -2px #ccc !important;
}

.logo{
  cursor: pointer
}

.powered{
  display: flex;
  justify-content: flex-end;
  padding: 10px 10px 10px 0;
  min-width: $menuWidthOpened;
  .logo-image{
    height: 32px !important;
  }
}

.menu-container{
  background-color: white;
  height: $toolbarHeight;
  width: calc(100vw - #{$menuWidthClosed});
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
}

.sub-menu-text{
  padding-left: 55px;
}

.profile{
  @media only screen and (max-width: 960px) {
    display: none;
  }
}

::v-deep .md-list-item-container{
  border: none !important;
}

::v-deep .neo-ai-icon svg {
  fill: var(--md-theme-default-primary) !important;
}

</style>